module.exports = __webpack_public_path__ + "static/kvm_8.1dbc1c81.jpg";